import {
  customCellOKorNot,
  customName,
  numberCell,
  customServiceRequest
} from './daily-production.helper'

export const columns = [
  {
    field: 'no',
    title: 'No',
    width: '80px',
    render: 'Report',
    left: '0px',
    customCell: numberCell
  },
  {
    field: 'vessel_name',
    title: 'Vessel Name',
    width: '300px',
    render: 'Report',
    left: '80px',
    customCell: customName
  },
  {
    field: 'sr_no',
    title: 'Service Request',
    width: '150px',
    render: 'Report',
    left: '380px',
    customCell: customServiceRequest
  },
  {
    field: 'buyer',
    title: 'Buyer',
    width: '150px',
    render: 'Report'
  },
  {
    field: 'br',
    title: 'B/R',
    width: '100px',
    render: 'Report'
  },
  {
    field: 'sr',
    title: 'S/R',
    width: '100px',
    render: 'Report',
    customCell: customCellOKorNot
  },
  {
    field: 'sr_vr',
    title: 'Surveyor',
    width: '200px',
    render: 'Report'
  },
  {
    title: 'Loading Permit',
    render: 'Report',
    width: '200px',
    children: [
      {
        field: 'loading_permit_request',
        title: 'Request',
        width: '100px',
        render: 'Report',
        customCell: customCellOKorNot
      },
      {
        field: 'loading_permit_approval',
        title: 'Approval',
        width: '100px',
        render: 'Report',
        customCell: customCellOKorNot
      }
    ]
  },
  {
    field: 'insp',
    title: 'INSP BY CUSTOM/PHO',
    width: '120px',
    render: 'Report',
    customCell: customCellOKorNot
  },
  {
    field: 'inapornet',
    title: 'Inapornet',
    width: '100px',
    render: 'Report',
    customCell: customCellOKorNot
  },
  {
    field: 'ga',
    title: 'GA',
    width: '250px',
    render: 'Report'
  },
  {
    field: 'eta',
    title: 'ETA',
    width: '200px',
    render: 'Report'
  },
  {
    field: 'arrival',
    title: 'ARRIVED',
    width: '200px',
    render: 'Report'
  },
  {
    title: 'LAY/CAN',
    render: 'Report',
    width: '400px',
    children: [
      {
        field: 'laycan_start',
        title: 'Form',
        width: '200px',
        render: 'Report'
      },
      {
        field: 'laycan_end',
        title: 'To',
        width: '200px',
        render: 'Report'
      }
    ]
  },
  {
    field: 'commence_loading_date',
    title: 'COMMENCE LOADING',
    width: '200px',
    render: 'Report'
  },
  {
    field: 'stowage_plan',
    title: 'STOWAGE PLAN',
    width: '200px',
    render: 'Report'
  },
  {
    field: 'ship_quantity',
    title: 'SHIPPED QUANTITY',
    width: '200px',
    render: 'Report'
  },
  {
    field: 'daily_production',
    title: 'DAILY PRODUCTION',
    width: '150px',
    render: 'Report'
  },
  {
    field: 'balance',
    title: 'BALANCE',
    width: '100px',
    render: 'Report'
  },
  {
    field: 'departure',
    title: 'COMPLETED DATE',
    width: '200px',
    render: 'Report'
  },
  {
    field: 'remarks',
    title: 'REMARKS',
    width: '300px',
    render: 'Report'
  },
  {
    field: 'delay_duration_value',
    title: 'DELAY DURATION',
    width: '300px',
    render: 'Report'
  },
  {
    title: 'BARGE LOADING',
    render: 'Report',
    width: '200px',
    children: [
      {
        field: 'barge_loading_barges',
        title: 'Barges',
        width: '100px',
        render: 'Report'
      },
      {
        field: 'barge_loading_quantity',
        title: 'Quantity',
        width: '100px',
        render: 'Report'
      }
    ]
  }
]
